export default function rewardTeamData (origin) {
    if (origin.length) {
      return origin.map(item => {
        return {
          name: item.Name,
          text: item.Text
        }
      })
    } else {
      return [
        {
          name: 'ios',
          text: 'a'
        },
        {
        name: 'ios',
        text: 'a'
        },{
        name: 'ios',
        text: 'a'
        },{
        name: 'ios',
        text: 'a'
        }
      ]
    }
  }


// WEBPACK FOOTER //
// ./src/utils/formattings/rewardTeamData.js